module.exports = "<router-outlet>\n    <hotjar *ngIf=enableHotjar tracking-id=\"958104\" version=\"6\"></hotjar>\n</router-outlet>\n"